export default __webpack_public_path__ + "static/media/Group 46_2.e34c65ce.svg";